/**
 * Per-platform carousel rules shared between canvas editor, validators, and
 * publish payload builders.
 *
 * - max: hard cap on slide count in a single draft.
 * - minPublish: minimum slides required for the carousel publish path
 *   (CAROUSEL post_type + carousel_media).
 * - allowVideo: whether VIDEO-typed slides are accepted. Facebook Graph API
 *   only supports multi-photo via `attached_media` on /feed — no mixed video.
 */
export type CarouselPlatformKey = "INSTAGRAM" | "FACEBOOK";

export const CAROUSEL_LIMITS: Record<
  CarouselPlatformKey,
  { max: number; minPublish: number; allowVideo: boolean }
> = {
  INSTAGRAM: { max: 10, minPublish: 2, allowVideo: true },
  FACEBOOK: { max: 10, minPublish: 2, allowVideo: false },
};

export function getCarouselLimits(platform: string | undefined | null) {
  const key = String(platform ?? "").toUpperCase();
  if (key === "FACEBOOK") return CAROUSEL_LIMITS.FACEBOOK;
  // Default to Instagram rules (back-compat with prior IG-only behavior).
  return CAROUSEL_LIMITS.INSTAGRAM;
}

/** @deprecated Use CAROUSEL_LIMITS.INSTAGRAM.max. */
export const INSTAGRAM_CAROUSEL_MAX_SLIDES = CAROUSEL_LIMITS.INSTAGRAM.max;

/** @deprecated Use CAROUSEL_LIMITS.INSTAGRAM.minPublish. */
export const INSTAGRAM_CAROUSEL_MIN_PUBLISH_SLIDES =
  CAROUSEL_LIMITS.INSTAGRAM.minPublish;
